import { ContactListItemPopover } from './contact-list-item.popover';
import { ContactService } from 'app/services/contact.service';
import { ContactSearchParamsModel } from 'app/models/dms/contactSearchParams.model';
import { ContactResultModel, ContactModel } from 'app/models/dms/contact.model';
import { DecimalPipe } from '@angular/common';

import { ContactType, ContactClass } from 'app/utility/enums';

import { StorageService } from 'app/services/storage.service';

import { NavController, AlertController, ActionSheetController, PopoverController, LoadingController } from '@ionic/angular';

import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, Renderer2 } from '@angular/core';

import { parsePhoneNumberFromString, PhoneNumber } from 'libphonenumber-js';
import { UserService } from 'app/services/user.service';

@Component({
    selector: 'app-contact-list-item',
    templateUrl: './contact-list-item.component.html',
    styleUrls: ['./contact-list-item.component.scss'],
    standalone: false
})
export class ContactListItemComponent implements OnInit
{

	@Input() inParams: ContactSearchParamsModel;
	@Input() contact: ContactResultModel;
	@Input() allowActions: boolean = true;
	@Input() display: 'card' | 'grid' = "card";

	@Input() type: 'data' | 'header' | 'skeleton' = "data";
	@Input() detailIcon: 'chevron-forward' | '' = '';
	@Output() selected = new EventEmitter<any>();

	contactTapped: boolean = false;


	constructor(
		public navCtrl: NavController,
		public alertController: AlertController,
		public actionSheetController: ActionSheetController,
		public renderer: Renderer2,
		public elRef: ElementRef,
		public storage: StorageService,
		public popoverController: PopoverController,
        public loadingController: LoadingController,
        public contactService: ContactService,
        public userService: UserService,
	) { }

	primaryAttributes: string[];
	secondaryAttributes: string[];

	priceInfoVisible: boolean = false;

	contact_details_width: number = 150;
	thumbWidth: number = 56;
	saleStatusCaption: string = "";

	ngOnInit()
	{
		if (this.type != 'data')
		{
			return;
		}
		this.contactTapped = false;
		this.contact_details_width = Math.round(window.innerWidth * 0.6);


		const phoneNumber = parsePhoneNumberFromString(this.contact.mobile, "NZ");
		if (phoneNumber) {
			this.phoneCaption = phoneNumber.formatInternational();
		}

		this.cardTitle = this.contact.displayName? this.contact.displayName : '';
		if (this.contact.name!='' && this.contact.displayName!=this.contact.name) {
			this.cardTitle +=' ['+this.contact.name+']';
		}

		this.cardSubRow1 = this.phoneCaption;
		if (!this.phoneCaption) {
			this.cardSubRow1 = this.contact.mobile?this.contact.mobile:"No number";
		}
		this.cardSubRow2 = this.contact.primaryEmail?this.contact.primaryEmail:"No email";
		// this.cardSubRow3 = this.contact.opportunityCount + '';
		this.saleStatusCaption = (this.contact.salesStatus)?this.contact.salesStatus.replace(/([A-Z])/g, ' $1').trim():"";

	}
	phoneCaption: string = "";
	screenMode: string = "xl";
	screenWidth: number = 0;

	cardClass: string = "opportunity-list-item";
	cardTitle: string = "";
	contactInitials: string = "";
	cardSubRow1: string = "";
	cardSubRow2: string = "";
	cardSubRow3: string = "";
	cardSubRow3Class: string = "";
	statusTitle: string = "";
	statusClass: string = "skeleton";

	rowClicked () {
		this.loadContact();
	}
	viewContact()
	{
		this.loadContact();
	}

	hasContact(): boolean
	{
		return (this.contact) ? true : false;
	}

	public loadContact(action: string = "")
	{
		this.contactTapped = true;
		switch (action)
		{
			case 'opportunities':
				this.selected.emit({ action: 'opportunities', contact: this.contact });
				break;
			default:
				this.selected.emit(this.contact);
				break;
		}
	}

	public navigateForward(page)
	{
		this.navCtrl.navigateForward(page);
	}

	async presentActionSheet()
	{



	}

	public contactCssClass()
	{
		return (this.contact.contactClass == ContactClass.Business ? "business" : "individual") + " " + (this.contact.contactType == ContactType.Supplier ? "supplier" : "customer");
	}


	async presentPopover(ev: any)
	{
        ev.preventDefault();
        if (!this.popoverController) return
		const phoneNumber = parsePhoneNumberFromString(this.contact.mobile, "NZ");
		var phone = (phoneNumber && phoneNumber.isValid()) ? phoneNumber.formatInternational() : "";
		var email = (this.contact.primaryEmail) ? this.contact.primaryEmail.toLowerCase() : "";

		const popover = await this.popoverController.create({
			component: ContactListItemPopover,
			componentProps: {
				contact: this.contact,
				phone: phone,
				email: email,
                contactIsActive: this.contact.active
			},
			event: ev,
			translucent: true
		});

		popover.onDidDismiss().then(
			(d: any) => this.handlePopoverDismiss(d)
		);
		return await popover.present();
	}
	handlePopoverDismiss = ({ data }) =>
	{
		const phoneNumber = parsePhoneNumberFromString(this.contact.mobile, "NZ");
		switch (data)
		{
			case "activity":
				this.selected.emit({ action: 'activity', contact: this.contact });
				break;
			case "phone":
				if (phoneNumber && phoneNumber.isValid())
				{
					window.location.href = phoneNumber.getURI();
				}
				break;
			case "email":
				if (this.contact.primaryEmail)
				{
					window.location.href = 'mailto:' + this.contact.primaryEmail;
				}
				break;
			case "sms":
				if (phoneNumber && phoneNumber.isValid())
				{
					window.location.href = 'sms:' + phoneNumber.formatInternational();
				}
				break;
			case "view":
				this.loadContact();
				break;
			case "opportunities":
				this.navCtrl.navigateForward('/contacts/' + this.contact.id + '/opportunities');
				break;
            case "change-activation":
                this.toggleContactActivation();
                break;
            case "delete-contact":
                this.deleteContact();
                break;
		}
	}

    contactActive: boolean = true;
    async toggleContactActivation()
    {
        const alert = await this.alertController.create({
            header: "Confirm",
            message: "Are you sure you want to change the activation status of this contact?",
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'primary',
                    handler: () =>
                    {
                        return;
                    }
                },
                {
                    text: 'Yes',
                    cssClass: 'danger',
                    handler: async () =>
                    {

                        const loading = await this.loadingController.create({
                            message: 'Saving',
                            duration: 60000
                        });
                        await loading.present();

                        this.contactService.updateContactActive(this.contact.id, !this.contact.active).subscribe({
                            next: x =>
                            {
                                this.contact.active = x;
                                this.contactActive = x;

                                loading.dismiss();
                            },
                            error: err =>
                            {
                                loading.dismiss();
                                this.userService.handleError(err);
                            }
                        });

                    }
                }
            ]
        });

        alert.present();

    }

    async deleteContact()
    {
        const alert = await this.alertController.create({
            header: "Delete",
            message: "Are you sure you want to delete "+ this.contact.displayName +"?",
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'primary',
                    handler: () =>
                    {
                        return;
                    }
                },
                {
                    text: 'Yes',
                    cssClass: 'danger',
                    handler: async () =>
                    {

                        const loading = await this.loadingController.create({
                            message: 'Deleting...',
                            duration: 60000
                        });
                        await loading.present();

                        this.contactService.deleteContact(this.contact.id)
                            .subscribe({
                                next: x =>
                                {
                                    this.selected.emit({ action: 'deleted', vehicle: this.contact });
                                    loading.dismiss();

                                },
                                error: err =>
                                {
                                    loading.dismiss();
                                    this.userService.handleError(err);
                                }
                            });

                    }
                }
            ]
        });

        alert.present();

    }
}


